export const FIELD_LOCK_DEBOUNCE_MS = 300;
